import{PreactRouter,observer,ComponentView,JSX,Preact,Id,Style,h,Cls,mc,Media,Head,CssVar,m,state,action,preventEvent,Link, Keyframes,CssElementName} from "@websites/website_compiler/Client";
export type divProps = JSX.IntrinsicElements["div"];
export type inputProps = JSX.IntrinsicElements["input"];
export type buttonProps = JSX.IntrinsicElements["button"];
export type aProps = JSX.IntrinsicElements["a"];
export type liProps = JSX.IntrinsicElements["li"];
export type labelProps = JSX.IntrinsicElements["label"];
export type textAreaProps = JSX.IntrinsicElements["textarea"];
export var MediaQuerySizes = {
    desktopLargeMin:2000,
    desktopMedMin:1800,
    desktopMin:1200,
    smallDesktopMin:950,
    tabletMin:650,
    phabletMin:550,
    mediumMobileMin:350,
}
export var PlaceholderText = {
    xxsmall:"Lorem ipsum dolor sit amet",
    xsmall:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod",
    small : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    med:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem."
}
